<app-table
    tableKey="dashboardSanction"
    [gridData]="$any(store.data.getWorks())"
    [hideCheckboxes]="true"
    [columns]="columns()"
    translatePrefix="dashboard.sanctions."
    [showSearch]="false"
    [showColumnVisiblity]="false"
    [showExport]="false"
    [showClearFilter]="false"
    [additionalFilter]="additionalFilters()"
    [refreshCallback]="store.api.getWorks"
    [refreshCallbackFragment]="getWorksFrag"
    [defaultSorters]="[{ column: 'dateFrom', direction: 'DESC' }]"
>
</app-table>
